import { render } from "./DocumentsPage.vue?vue&type=template&id=af93fa96&scoped=true"
import script from "./DocumentsPage.vue?vue&type=script&lang=js"
export * from "./DocumentsPage.vue?vue&type=script&lang=js"

import "./DocumentsPage.vue?vue&type=style&index=0&id=af93fa96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af93fa96"]])

export default __exports__